"use client";

import { Toast, ToastBody, ToastFooter, ToastProps, ToastTitle } from "@fluentui/react-components";
import { useTranslations } from "next-intl";
import { JSX } from "react";

interface AppToastProps extends ToastProps {
  title?: string;
  content?: string;
  subtitle?: string;
  capitalized?: boolean;
  action?: JSX.Element | string;
  footer?: JSX.Element | string;
}

const AppToast = ({
  title,
  content,
  subtitle,
  capitalized = true,
  action,
  footer,
  ...rest
}: AppToastProps) => {
  const t = useTranslations();
  // console.log("[DBEUG] app toast title ", title);
  return (
    <Toast {...rest}>
      {title && (
        <ToastTitle className={`${capitalized ? "first-letter:uppercase" : ""}`} action={action}>
          {t(title)}
        </ToastTitle>
      )}
      {content && <ToastBody subtitle={t(subtitle)}>{t(content)}</ToastBody>}
      {footer && <ToastFooter>{t(footer)}</ToastFooter>}
    </Toast>
  );
};

export default AppToast;
